import React from "react";
import {
  View,
  StyleSheet,
  Modal,
  TouchableWithoutFeedback,
  ActivityIndicator,
  Text,
} from "react-native";
import { useSelector } from "react-redux";
import ConfirmBox from "./ConfirmBox";
import { getIsOrderProcessing } from "@/app/selectors/order";
import { processingStyles } from "./styles";
import { useTranslateText } from "@/app/utils/translations";

type OrderConfirmModalProps = {
  visible: boolean;
  onClose: () => void;
};

const OrderConfirmModal = ({ visible, onClose }: OrderConfirmModalProps) => {
  const isOrderProcessing = useSelector(getIsOrderProcessing);
  const { t } = useTranslateText();

  return (
    <Modal
      transparent={true}
      animationType="fade"
      visible={visible || isOrderProcessing}
      onRequestClose={onClose}
      accessibilityViewIsModal={true}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View
          style={styles.backdrop}
          accessible={true}
          accessibilityRole="alert"
          accessibilityLabel={
            isOrderProcessing
              ? "Order is being processed"
              : "Order confirmation dialog"
          }
        >
          {isOrderProcessing ? (
            <TouchableWithoutFeedback>
              <View
                style={processingStyles.container}
                testID="processing-indicator"
              >
                <ActivityIndicator size="large" color="white" />
                <Text style={processingStyles.header}>
                  {t("tpos.orderArea.processingOrder")}
                </Text>
                <Text style={processingStyles.subtext}>
                  {t("tpos.orderArea.processingOrderText")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
          ) : (
            <TouchableWithoutFeedback>
              <ConfirmBox onEditOrderPress={onClose} />
            </TouchableWithoutFeedback>
          )}
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default OrderConfirmModal;
